// config/Autenticacion.js - FIX URGENTE
import axios from 'axios';

const BASE_URL = process.env.NODE_ENV === 'production'
  ? 'https://fcn-api-platform-hzcfayfsc0gebfhw.centralus-01.azurewebsites.net'
  : 'http://localhost:3000/api-central';
const PORTAL_URL = process.env.REACT_APP_PORTAL_URL;
const APP_ID = process.env.REACT_APP_APLICACION_ID;
const isDev = process.env.NODE_ENV === 'development';
 

 
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
};
 
// FIX: FUNCIÓN GETCURRENTTOKEN CORREGIDA
export const getCurrentToken = () => {
  if (process.env.NODE_ENV === 'development') {
    return process.env.REACT_APP_SESSION_ID;
  }

  // En producción, leer cookie directamente
  return document.cookie
    .split('; ')
    .find(row => row.startsWith('sessionId='))
    ?.split('=')[1] || null;
};
 
const Autenticacion = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  withCredentials: process.env.NODE_ENV === 'development', // Solo en desarrollo
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});
 
// FIX: INTERCEPTOR CORREGIDO
Autenticacion.interceptors.request.use(
  (config) => {
  
   
    if (!config.url?.includes('/auth/')) {
      config.headers['X-Aplicacion-Id'] = APP_ID;
    }
 
    // FIX: USAR getCurrentToken SIEMPRE
    const token = getCurrentToken();
   
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
    }
   
  
    return config;
  },
  (error) => {
 
    return Promise.reject(error);
  }
);
 
Autenticacion.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
   
    if (error.response?.status === 401) {
   
    }
   
    return Promise.reject(error);
  }
);
 
// FIX: VERIFY SESSION MEJORADO
export const verifySession = async () => {
  try {

   
    const token = getCurrentToken();
    if (!token) {
 
      return {
        success: false,
        error: 'No hay token disponible',
        needsAuth: true
      };
    }
 
    const response = await Autenticacion.get('/auth/verify-session');
   
  
   
    const { data } = response;
   
    if (data.success && data.valid && data.user) {
   
      return {
        success: true,
        user: data.user,
        permissions: data.permissions || data.permisos || []
      };
    } else {
    
      return {
        success: false,
        error: 'Sesión inválida',
        needsAuth: true
      };
    }
  } catch (error) {

   
    return {
      success: false,
      error: error.message || 'Error de conexión',
      needsAuth: true
    };
  }
};
 
export const logoutUser = () => {
  // En desarrollo: limpiar storage Y redirigir al portal
  if (isDev) {
    sessionStorage.clear();
    localStorage.clear();
  }
 
  // SIEMPRE redirigir al portal (desarrollo y producción)
  window.location.href = PORTAL_URL;
  return true;
};
 
 
export default Autenticacion;
